import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SessionService } from '@monsido/core/session/session.service';

@Injectable({
    providedIn: 'root',
})

export class ForethoughtProvider {
    private loaded = false;

    constructor (
        @Inject(DOCUMENT) private document: Document,
        private sessionService: SessionService,
    ) {}

    addScript (): void {
        if (this.shouldStartIntercom()) {
            this.initScript(this.sessionService.getChatSystemOptions());
        }
    }

    private shouldStartIntercom (): boolean {
        return !this.loaded;
    }

    private initScript (options?: any): void {
        const script = this.document.createElement('script');
        script.nonce = 'cb56f32a13f';
        script.src = 'https://solve-widget.forethought.ai/embed.js';
        script.id = 'forethought-widget-embed-script';
        script.setAttribute('initial-intent-id', '');
        script.setAttribute('data-api-key', options.apiKey);
        script.setAttribute('data-ft-Embed-Script-Language', options.language || 'English');
        script.setAttribute('data-ft-Workflow-Tag', options.workflowTag);
        script.setAttribute('config-ft-placement', 'bottom_right');
        script.setAttribute('data-ft-Email', '');
        script.setAttribute('hidden', 'absent');

        this.loaded = true;
        this.document.body.appendChild(script);
    }
}

